import { useTranslation } from 'react-i18next';
import { cancellationNoteData, type CancellationSource } from '../../utils/cancellationNote';
import { formatDate } from '../../utils/format';

/** FQ-065 — "סיבת ביטול: …" + the cancel date, under the header of a cancelled project / engagement. */
export default function CancellationNote({ source }: { source: CancellationSource | null | undefined }) {
  const { t } = useTranslation();
  const note = cancellationNoteData(source);
  if (!note) return null;
  return (
    <p className="text-xs text-surface-600" data-testid="cancellation-note">
      {note.reason && <bdi>{t('cancellationNote.reason', { reason: note.reason })}</bdi>}
      {note.reason && note.cancelledAt && ' · '}
      {note.cancelledAt && t('cancellationNote.date', { date: formatDate(note.cancelledAt) })}
    </p>
  );
}
